import { initializeApp } from "firebase/app"
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyDWEACJABgAwtV32rE51yE4dGgIwh_HE5o",
  authDomain: "anmol-furniture-bazaar-store.firebaseapp.com",
  projectId: "anmol-furniture-bazaar-store",
  storageBucket: "anmol-furniture-bazaar-store.firebasestorage.app",
  messagingSenderId: "867354072049",
  appId: "1:867354072049:web:0f8bd56aa635624c73ea50",
  measurementId: "G-F56WPDH8XZ"
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

// Debug: Log current domain (remove this after fixing)
console.log("Current domain:", window.location.hostname)

// Explicitly set session persistence
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Failed to set Firebase Auth persistence:", error)
  })

auth.useDeviceLanguage()

export const db = getFirestore(app)
export const storage = getStorage(app)
